function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M259.2,132.7c-5.7,0.5-11.2,1.1-16.8,1.6c-3.9,0.4-7.9,0.7-11.7,1.1c-82.9,8-159.9,17.2-229.9,27.3 c74.8-5.4,153.5-10.2,234.9-14.5l13.1,32.4c1.1,2.9,4.2,4.9,7.4,4.9h33.4c3.1,0,6.2-2,7.4-4.9l21.5-53.1 C298.4,129.2,278.7,131,259.2,132.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M2141.1,162.7c-56.2-8.1-117-15.6-181.5-22.4v-0.1c-2.7-0.3-5.5-0.5-8.2-0.8c-0.6-0.1-1.2-0.1-1.8-0.2 c-11.4-1.2-22.7-2.4-34.4-3.5v44.4c0,2.9,2.4,5.4,5.3,5.4h33.7c2.9,0,5.4-2.5,5.4-5.4v-29C2022.2,154.7,2082.8,158.5,2141.1,162.7z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M360.1,1.1h-37.9c-3.1,0-6,2-7.1,4.9l-40.6,107.7c-0.4,1.6-2.7,1.6-3.1,0L231,6c-1.1-2.9-4-4.9-7.1-4.9H186 c-2.7,0-4.2,2.7-3.3,4.9l48,118.8c28.6-2.8,58-5.4,87.9-7.9L363.4,6C364.3,3.8,362.7,1.1,360.1,1.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M474.9,105.7V6.5c0-2.9-2.5-5.4-5.4-5.4h-33.9c-2.9,0-5.4,2.5-5.4,5.4v102.1 C445.1,107.6,460,106.6,474.9,105.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M430.4,119.2v61.1c0,2.9,2.5,5.4,5.4,5.4h33.9c2.9,0,5.4-2.5,5.4-5.4v-64C460,117.2,445.1,118.2,430.4,119.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M621.3,97.7L586.9,6c-1.1-2.9-4-4.9-7.1-4.9h-37.9c-2.7,0-4.2,2.7-3.3,4.9l37.9,93.8 C591.3,99.1,606.2,98.4,621.3,97.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M724.5,1.1h-37.9c-3.1,0-6,2-7.1,4.9l-34.3,91.1c15.4-0.7,30.9-1.3,46.6-1.9l36-89.2 C728.8,3.8,727.2,1.1,724.5,1.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M633.8,124.3c-0.4,1.6-2.7,1.6-3.1,0l-6-16c-15.1,0.7-30,1.4-44.9,2.1l28.4,70.3c1.1,2.9,4.2,4.9,7.4,4.9H649 c3.1,0,6.2-2,7.4-4.9l30.3-74.9c-15.6,0.6-31.2,1.2-46.6,1.9L633.8,124.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M907.4,89.3V74.7c0-2.9-2.5-5.4-5.4-5.4h-63.3c-2.5,0-4.5-2-4.5-4.5v-16c0-2.4,2-4.4,4.5-4.4h79.1 c2.9,0,5.4-2.5,5.4-5.4V6.5c0-2.9-2.5-5.4-5.4-5.4H795c-2.9,0-5.4,2.5-5.4,5.4v85.4C828.4,90.8,867.8,89.9,907.4,89.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M917.9,142.6h-79.2c-2.5,0-4.5-2-4.5-4.5v-13.4c0-2.5,2-4.5,4.5-4.5H902c2.9,0,5.4-2.5,5.4-5.4v-15 c-39.7,0.6-79,1.5-117.7,2.5v77.8c0,2.9,2.5,5.4,5.4,5.4h122.8c2.9,0,5.4-2.5,5.4-5.4v-32.3C923.2,145,920.8,142.6,917.9,142.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1048.8,88.1c7.4,0,14.8,0,22.3,0c10.9,0,21.8,0,32.7,0.1l-66.3-82.8c-2-2.7-5.4-4.2-8.7-4.2h-27 c-2.9,0-5.4,2.5-5.3,5.4v81.9c14.7-0.1,29.5-0.2,44.4-0.2L1048.8,88.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1150.8,1.1H1117c-2.9,0-5.4,2.5-5.4,5.4v81.6c14.8,0.1,29.6,0.2,44.4,0.3V6.5 C1156.2,3.6,1153.7,1.1,1150.8,1.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1103.8,98.7c-10.9,0-21.8-0.1-32.7-0.1c-7.4,0-14.9,0-22.3,0l66.3,82.7c2,2.7,5.4,4.2,8.7,4.2h27 c2.9,0,5.4-2.5,5.4-5.4V99c-14.7-0.1-29.5-0.2-44.4-0.3H1103.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M996.4,98.9v81.3c0,2.9,2.5,5.4,5.4,5.4h33.7c2.9,0,5.4-2.5,5.4-5.4V98.7C1026,98.7,1011.2,98.8,996.4,98.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1371.3,1.1h-142.2c-2.9,0-5.3,2.5-5.3,5.4v32.6c0,2.9,2.5,5.4,5.4,5.4h44.4c2.5,0,4.5,2,4.5,4.4v41.3 c14.9,0.3,29.8,0.6,44.6,1V48.8c0-2.4,2-4.4,4.5-4.4h44.4c2.9,0,5.4-2.5,5.4-5.4V6.4C1376.7,3.6,1374.2,1.1,1371.3,1.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1277.8,100.7v79.6c0,2.9,2.4,5.4,5.4,5.4h33.9c2.9,0,5.4-2.5,5.4-5.4v-78.6 C1307.7,101.3,1292.8,101,1277.8,100.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1483.5,1.1h-33.9c-2.9,0-5.4,2.5-5.4,5.4v88.3c15,0.5,29.8,1.1,44.6,1.7v-90 C1488.8,3.6,1486.4,1.1,1483.5,1.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1444.2,180.2c0,2.9,2.5,5.4,5.4,5.4h33.9c2.9,0,5.4-2.5,5.4-5.4v-73.1c-14.8-0.6-29.6-1.2-44.6-1.7 L1444.2,180.2L1444.2,180.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1708.7,1.1h-33.7c-2.9,0-5.4,2.5-5.4,5.4v89.9c0,3.6-0.3,7-0.8,10.1c15,1,29.9,1.9,44.6,2.9 c0.4-3.4,0.6-6.9,0.6-10.4V6.5C1713.9,3.6,1711.5,1.1,1708.7,1.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1599,102.3c-0.2-2-0.4-3.9-0.4-6V6.5c0-2.9-2.4-5.4-5.4-5.4h-33.9c-2.9,0-5.4,2.5-5.4,5.4V99c0,0.3,0,0.7,0,1 C1569.2,100.7,1584.2,101.5,1599,102.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1633.9,145.9c-21.2,0-33-11.7-34.9-33c-14.9-0.8-29.8-1.6-44.9-2.4c0.4,44.3,28,78.4,79.8,78.4 c47.8,0,75.4-29.3,79.5-69c-14.7-1-29.6-2-44.6-2.9C1665.8,135.7,1653.9,145.9,1633.9,145.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1915.2,125.2c15,1.5,29.7,3,44.4,4.5V6.4c0-2.9-2.5-5.4-5.4-5.4h-34.1c-3.1,0-6.2,2-7.8,4.7l-45.9,91 c-0.9,1.8-3.1,1.8-4,0l-45.7-91c-1.6-2.7-4.7-4.7-7.8-4.7h-34.1c-2.9,0-5.4,2.5-5.4,5.4v106.2c14.9,1.1,29.7,2.3,44.4,3.5V90.3 c0-1.1,1.6-1.6,2-0.5l13.8,27.6c22.7,1.9,45,3.9,66.9,6l16.7-33.6c0.5-1.1,2-0.7,2,0.5V125.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1847.4,164c1.6,2.7,4.7,4.7,7.8,4.7h18.5c3.1,0,6.2-2,7.8-4.7l14.9-30c-21.9-2.1-44.2-4.1-66.9-6L1847.4,164z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1769.4,180.2c0,2.9,2.5,5.4,5.4,5.4h33.7c2.9,0,5.4-2.5,5.4-5.4v-53.5c-14.6-1.2-29.4-2.4-44.4-3.5 L1769.4,180.2L1769.4,180.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1974.5,173.9c0-7,5.7-12.7,12.7-12.7s12.7,5.7,12.7,12.7s-5.7,12.7-12.7,12.7S1974.5,180.9,1974.5,173.9z  M1976.2,173.9c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11c0-6.1-4.9-11-11-11C1981,162.9,1976.2,167.8,1976.2,173.9z M1992.3,179 c0.2,0.3-0.1,0.7-0.4,0.7h-0.1c-0.5,0-1-0.3-1.3-0.7l-1.8-3c-0.3-0.4-0.7-0.6-1.1-0.6h-2.7c-0.4,0-0.7,0.3-0.7,0.7v2.9 c0,0.4-0.3,0.7-0.7,0.7h-0.1c-0.4,0-0.7-0.3-0.7-0.7v-10.6c0-0.5,0.4-0.9,0.9-0.9h4.7c2.7,0,4.2,1.8,4.2,4c0,1.4-0.6,2.7-1.8,3.3 c-0.4,0.2-0.5,0.6-0.3,1L1992.3,179z M1988.2,169h-3.3c-0.4,0-0.7,0.3-0.7,0.7v3.3c0,0.4,0.3,0.7,0.7,0.7h3.3 c1.7,0,2.7-1.2,2.7-2.4C1990.9,170.2,1989.9,169,1988.2,169z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M1761.8,264.4c0-4.5,1.9-6.4,6.4-6.4h20.5c9.4,0,18,5.5,21.9,14c3.4,7.6,2.6,16.4-2.1,23.2l-0.4,0.6 c-4.7,6.8-12.5,10.8-20.8,10.8h-8.5c-1.2,0-2.2,1-2.2,2.2v27.7c0,0.2,0,0.3-0.1,0.5c-0.2,0.4-0.5,0.6-0.8,0.8c0,0-0.1,0-0.1,0 c-0.2,0.1-0.5,0.1-0.7,0.1h-11.2c-0.2,0-0.5-0.1-0.7-0.2c-0.3-0.1-0.7-0.5-0.8-0.8c0,0,0-0.1,0-0.1l0,0c-0.1-0.2-0.1-0.4-0.1-0.6 V264.4z M1776.5,292.1h10.7c3.5,0,6.7-1.7,8.7-4.5l0.4-0.6c1.8-2.7,2.2-6.1,0.8-9c-1.5-3.3-4.8-5.4-8.5-5.4h-12.2V292.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1895.2,258c-1.5,0-2.5,1.6-1.8,3l22.8,41.8c0.8,1.5,1.2,3.1,1.2,4.8V336c0,1.1,0.9,2,2,2h10.8 c1.1,0,2-0.9,2-2v-28.3c0-1.8,0.5-3.5,1.4-5.1l24.4-41.6c0.8-1.3-0.2-3-1.7-3h-13.6c-0.7,0-1.4,0.4-1.8,1.1l-15.3,29.4l-15.3-29.4 c-0.3-0.7-1-1.1-1.8-1.1H1895.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M1845.4,262.4c2.2-5.7,10-5.8,12.4-0.2l16.6,40.5l12.1,32.2c0.6,1.5-0.5,3.1-2.1,3.1h-11.9 c-0.9,0-1.8-0.6-2.1-1.5l-7.7-21.1c-0.3-0.9-1.2-1.5-2.1-1.5h-17.6c-1,0-1.8,0.7-2.1,1.6l-6.2,20.8c-0.3,1-1.2,1.6-2.1,1.6h-11.6 c-1.5,0-2.6-1.6-2.1-3l11.1-32.2L1845.4,262.4z M1858.9,301.1c0.8,0,1.3-0.8,1-1.6l-7.5-17.8c-0.4-0.9-1.7-0.9-2,0l-7.2,17.8 c-0.3,0.8,0.2,1.6,1,1.6H1858.9z"
}));

function SvgViventiumLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2142 339",
    style: {
      enableBackground: "new 0 0 2142 339"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViventiumLogo);
export default __webpack_public_path__ + "static/media/viventium-logo.4cbdfe09.svg";
export { ForwardRef as ReactComponent };